__turbopack_context__.v({
  "inner": "fqFjpW_inner",
  "loadingOverlay": "fqFjpW_loadingOverlay",
  "root": "fqFjpW_root",
  "wrapper": "fqFjpW_wrapper",
});
